import React from 'react'

import { render } from 'react-dom'
import { browserHistory } from 'react-router'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'

import {
  getMe,
  logout,
} from 'reduxpath/ducks/Auth'

import Root from 'units/Root'

import {
  isAuthorized,
  destroyUser,
  isGetCraftAccount,
} from 'utils/Auth'
import { sentryDSN } from 'configpath'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'

import configStore from './redux/store'
import getRoutes from './routes'

// Sentry only enabled on production environment (staging, beta, prod)
if (process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'test') {
  Sentry.init({
    dsn: sentryDSN,
    integrations: [new Integrations.BrowserTracing()],
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  })
}

const store = configStore()

function renderApp(err) {
  const routerConfig = {
    routes: getRoutes(store, err),
    history: browserHistory,
  }

  const muiTheme = getMuiTheme({
    fontFamily: "'Barlow', sans-serif",
    palette: {
      primary1Color: '#ee5e4b',
    },
    tooltip: {
      rippleBackgroundColor: '#fff',
      color: 'black',
    },
  })

  render((
    <MuiThemeProvider muiTheme={muiTheme}>
      <Root store={store} routerConfig={routerConfig} />
    </MuiThemeProvider>
  ), document.getElementById('app'))
}

const userData = new Promise((resolve) => {
  if (!isAuthorized()) {
    resolve({ err: null })
  }
  const token = JSON.parse(isAuthorized())
  store.dispatch(getMe(token, (tokenData, err) => {
    if (err || !isGetCraftAccount(tokenData.user.email)) {
      store.dispatch(logout())
      destroyUser()
      return resolve({ err })
    }

    return resolve({ err: null })
  }))
})

userData
  .then(async ({ err }) => {
    renderApp(err)
  })
